module.exports = __webpack_public_path__ + "static/media/people-outline.eab30ff4.svg";